export default class TimelineController {
    constructor(data, options = { onShow: () => {} }) {
        this.data = data;
        this.options = options;
    }

    Update(time) {
        const visibleItems = [];

        Object.keys(this.data).forEach((key) => {
            const value = this.data[key];

            const period = key.split('-');

            if (this.checkTime(parseInt(period[0], 10), parseInt(period[1], 10), time)) {
                visibleItems.push(value);
            }
        });

        if (this.options.onShow) this.options.onShow(visibleItems);
    }

    checkTime = (start, end, time) => {
        if (time >= start && time <= end) return true;

        return false;
    };
}
